###
Formats an input element realtime for use with currencies
###
angular
	.module 'App.Directive'
	.factory 'getFormat', (parseBool) ->
		(params) ->
			format =
				prefix: ''
				suffix: ''
				centsSeparator: '.'
				thousandsSeparator: ','
				limit: false
				centsLimit: 2
				clearPrefix: false
				clearSufix: false
				allowNegative: false
				insertPlusSign: false
				clearOnEmpty: false
				asFloat: false

			for own param, value of format
				if angular.isDefined params[param]
					# centsLimit must be int, otherwise it brakes parseFormat library
					if param == 'centsLimit'
						format[param] = parseInt(params[param])

						continue

					if ['prefix', 'suffix', 'centsSeparator', 'thousandsSeparator', 'limit'].includes(param)
						format[param] = params[param]

						continue

					format[param] = parseBool(params[param])

			return format
	.directive 'format', (getFormat, parseBool) ->
		require: '?ngModel'
		link: (scope, elem, attrs, ctrl) ->
			if !ctrl
				return

			format = getFormat(attrs)

			ctrl.$parsers.unshift ->
				elem.priceFormat format

				if elem.val() == '' && parseBool(attrs.clearOnEmpty)
					return null

				ctrl.$setViewValue(elem[0].value)

				if format.asFloat
					return elem.priceToFloat()
				else
					return parseInt(elem.unmask())

			ctrl.$formatters.unshift ->
				if parseBool(attrs.clearOnEmpty)
					elem[0].value = ctrl.$modelValue
				else
					elem[0].value = ctrl.$modelValue || 0
				elem.priceFormat format

				return elem[0].value

	.filter 'format', (getFormat) ->
		return (number, thousandsSeparator = ',', centsSeparator = '.', centsLimit = 2, clearOnEmpty = false) ->
			format = getFormat
				thousandsSeparator: thousandsSeparator
				centsSeparator: centsSeparator
				centsLimit: centsLimit
				clearOnEmpty: clearOnEmpty

			return angular
				.element '<i>'
				.text number
				.priceFormat format
				.text()
